import Script from "next/script"
import Image from "components/Image"
import { getAllBlogArticlePaths, getBlogArticle, getGlobals } from "storyblok/api"
import Meta from "components/Meta"
import SidebarSection from "components/SidebarSection"
import richText from "utilities/richText"
import { getExcerpt } from "utilities/getExcerpt"
import { formatBlogDate } from "utilities/blogHelpers"

export default function content({ content: { content: content }, meta }) {
  return (
    <>
      <Meta
        info={{
          title: `${content?.title}`,
          og_title: `${content?.title}`,
          twitter_title: `${content?.title}`,
          description: `${getExcerpt(content?.content)}`,
          og_description: `${getExcerpt(content?.content)}`,
        }}
      />
      <article>
        <header className="bg-dark-blue-to-blue-inverted text-white py-16 ">
          <div className="container mx-auto flex flex-col lg:flex-row justify-between max-w-screen-xl 2xl:max-w-screen-2xl m-auto gap-4">
            <div className="lg:w-3/5 flex-col flex justify-center items-start mx-auto lg:mx-0 lg:pr-8 prose 2xl:max-w-[80ch]">
              <h1 className="text-white text-l2 md:text-xl1 lg:text-xl2 font-semibold mb-3">{content.title}</h1>
              <span className="eyebrow eyebrow-2 text-green-kelly">
                {content.date && <time dateTime={content.date}>{formatBlogDate(new Date(content.date))}</time>}
                {content.date && content.author && <> | </>}
                {content.author && <>{content.author}</>}
              </span>
              {content.excerpt && <p className="mt-8 text-white">{richText(content.excerpt)}</p>}
            </div>
            <div className="hidden lg:flex flex-col lg:w-2/5">
              {content.featured_image?.filename && (
                <Image
                  className="rounded-4xl"
                  width="630"
                  height="420"
                  src={content.featured_image?.filename}
                  alt={content.featured_image?.alt ?? "Decorative Image"}
                />
              )}
            </div>
          </div>
        </header>
        <SidebarSection content={content.content} />
      </article>
      <Script type="application/ld+json" id="blog-article-schema">
        {`{
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "headline": "${content?.title}",
          "image": [
            "${content?.featured_image?.filename ?? ""}"
          ],
          "author": {
            "@type": "Person",
            "name": "${content.author}
          }
        }`}
      </Script>
    </>
  )
}

export async function getStaticProps({ params: { slug } }) {
  const globals = await getGlobals()
  const content = await getBlogArticle(slug)

  return {
    props: {
      content: content ?? null,
      globals: globals ?? null,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getAllBlogArticlePaths(),
    fallback: false,
  }
}
